import {DependencyList, EffectCallback, useEffect, useRef} from 'react'

/** useEffect hook that skips first invocation */
export const useSkip = (effect: EffectCallback, deps?: DependencyList) => {
	const skipped = useRef(false)
	useEffect(() => {
		if (!skipped.current) {
			skipped.current = true
			return
		}
		return effect()
	}, deps)
}
